var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-help", class: [_vm.packageName] },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(" " + _vm._s(_vm.$t("lang.mybean.beans")) + " "),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "tit-right",
                        on: {
                          click: function ($event) {
                            return _vm.toPage("/income/details")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lang.mybean.details")) + " "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "beans" }, [
          _c("div", { staticClass: "beans-num" }, [
            _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
            _vm._v(" " + _vm._s(_vm.data.remainIncomeAmount) + " "),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.wd.myBalance")))]),
        ]),
        _c("div", { staticClass: "income" }, [
          _c("div", { staticClass: "income-box total-income" }, [
            _c("div", { staticClass: "num" }, [
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _vm._v(" " + _vm._s(_vm.data.sumIncomeAmount) + " "),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.totalIncome")))]),
            _vm.packageName === "kiko"
              ? _c("img", {
                  staticClass: "time",
                  attrs: { src: require("./images/report-kiko.png"), alt: "" },
                  on: {
                    click: function ($event) {
                      return _vm.toPage("/income/report")
                    },
                  },
                })
              : _c("img", {
                  staticClass: "time",
                  attrs: {
                    src: require("@/assets/packageAssets/views/P1_Girls/MyBeans/vava/time.png"),
                    alt: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toPage("/income/report")
                    },
                  },
                }),
          ]),
          _c("span", { staticClass: "line" }),
          _c("div", { staticClass: "income-box week-income" }, [
            _c("div", { staticClass: "num" }, [
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _vm._v(" " + _vm._s(_vm.data.thisWeekIncomeAmount) + " "),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.thisWeekIncome")))]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "myincome-list" },
          _vm._l(_vm.list.keys(), function (key, index) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "list-item",
                class: {
                  todayIncome: key == _vm.$t("lang.mybean.todaytIncome"),
                  lineBottom:
                    key == _vm.$t("lang.mybean.todaytIncome") ||
                    key == _vm.$t("lang.mybean.others"),
                },
              },
              [
                _c("span", [_vm._v(_vm._s(key))]),
                _c("div", { staticClass: "myincome-beans" }, [
                  _c("i", [_vm._v(_vm._s(_vm.list.get(key)))]),
                  index <= 7
                    ? _c("img", {
                        attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                      })
                    : _vm._e(),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "withdrawal-box",
          style: { "margin-bottom": `${_vm.bottomBarHeight}px` },
        },
        [
          _c(
            "div",
            {
              staticClass: "withdrawal",
              on: {
                click: function ($event) {
                  return _vm.toPage("/withdrawal")
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("lang.sevenKeepSignin.withdraw")) + " "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }